module.exports = __webpack_public_path__ + "img/email.5d86f7bf.svg";